<!--
/*
 * @Author: your name
 * @Date: 2021-07-05 20:00:34
 * @LastEditTime: 2021-07-19 13:50:53
 * @LastEditors: lyy
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\views\ProjectProgress\ProjectProgressUpdateDelegation.vue
 * @Description: 项目进度查询和办理 - 更改委托信息【与测绘项目委托 - 项目委托一致，直接使用项目委托页面，当前页面暂未使用】
 */
 -->
<template>
  <div
    id="project-progress-update-delegation"
    class="project-progress-update-delegation"
  >
    <div class="content-box">
      <div class="page-title">基本信息</div>
      <div class="form-box">
        <van-form>
          <div class="form-panel">
            <div class="item-title">
              <div class="title-text">建设单位</div>
            </div>
            <van-field
              v-model="projectInfo.buildingEnt"
              class="border-field info-readonly"
              readonly
            />
          </div>
          <div class="form-panel">
            <div class="item-title">
              <div class="title-text">工改项目编号</div>
            </div>
            <van-field
              v-model="projectInfo.code"
              class="border-field info-readonly"
              readonly
            />
          </div>
          <div class="form-panel">
            <div class="item-title">
              <div class="title-text">工建项目名称</div>
            </div>
            <van-field
              v-model="projectInfo.projectName"
              class="border-field info-readonly"
              readonly
            />
          </div>

          <div class="form-panel">
            <div class="item-title">
              <div class="title-text">项目详细地址</div>
            </div>
            <van-field
              v-model="projectInfo.projectAddress"
              class="border-field info-readonly"
              readonly
            />
          </div>
          <div class="form-panel">
            <div class="item-title">
              <div class="title-text">工建项目类型</div>
            </div>
            <van-field
              v-model="projectInfo.projectType"
              class="border-field info-readonly"
              readonly
            />
          </div>
          <div class="form-panel">
            <div class="item-title">
              <div class="title-text">多测项目类型</div>
            </div>
            <van-field
              v-model="projectInfo.multiType"
              class="border-field info-readonly"
              readonly
            >
              <template #button>
                <div class="selectBtn" @click="onselectMultiType">选择</div>
              </template>
            </van-field>
          </div>

          <div class="form-panel">
            <div class="item-title">
              <div class="title-text">联系人</div>
            </div>
            <van-field v-model="projectInfo.contactor" class="border-field" />
          </div>
          <div class="form-panel">
            <div class="item-title">
              <div class="title-text">联系电话</div>
            </div>
            <van-field v-model="projectInfo.mobile" class="border-field" />
          </div>

          <div class="form-panel">
            <div class="item-title">
              <div class="title-text">测绘服务事项</div>
            </div>
            <div class="service-form">
              <div class="service-form-item">
                <span class="service-item-title">1.立项用地规划许可阶段</span>
                <van-checkbox-group v-model="lianResult">
                  <van-checkbox name="a" shape="square"
                    >土地供应测绘</van-checkbox
                  >
                  <van-checkbox name="b" shape="square"
                    >建设用地地籍调查</van-checkbox
                  >
                </van-checkbox-group>
              </div>

              <div class="service-form-item">
                <span class="service-item-title">2.工程规划许可阶段</span>
                <van-checkbox-group v-model="xukeResult">
                  <van-checkbox name="a" shape="square"
                    >规划初始验线测量</van-checkbox
                  >
                </van-checkbox-group>
              </div>

              <div class="service-form-item">
                <span class="service-item-title"
                  >3.工程建设许可与施工监督阶段</span
                >
                <van-checkbox-group v-model="jianduResult">
                  <van-checkbox name="a" shape="square"
                    >规划过程验线测量</van-checkbox
                  >
                  <van-checkbox name="b" shape="square"
                    >房产面积预测绘</van-checkbox
                  >
                </van-checkbox-group>
              </div>

              <div class="service-form-item">
                <span class="service-item-title">4.竣工验收阶段</span>
                <van-checkbox-group v-model="yanshouResult">
                  <van-checkbox name="a" shape="square"
                    >竣工验收测量</van-checkbox
                  >
                </van-checkbox-group>
              </div>

              <div class="service-form-item">
                <span class="service-item-title">5.不动产登记阶段</span>
                <van-checkbox-group v-model="budongchanResult">
                  <van-checkbox name="a" shape="square"
                    >房产面积测绘</van-checkbox
                  >
                </van-checkbox-group>
              </div>
            </div>
          </div>
          <div class="form-panel">
            <div class="item-title">
              <div class="title-text">测绘作业单位</div>
            </div>
            <van-field
              v-model="projectInfo.measureEnt"
              class="border-field info-readonly"
              readonly
            >
              <template #button>
                <div class="selectBtn" @click="onselectMeasure">选择</div>
              </template>
            </van-field>
          </div>

          <div class="tips">
            <span class="tips-text">温馨提示：测绘单位数据来自于</span>
            <span class="tips-url" @click="queryUnit">“测绘作业单位查询”</span>
          </div>

          <div class="btn-box">
            <van-button
              class="btn-submit"
              block
              type="info"
              native-type="submit"
              >重新提交</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from '@/components/NoData.vue'
import listMixins from '@/mixins/comListMixins'
export default {
  name: 'projectProgressUpdateDelegation',
  mixins: [listMixins],
  components: {
    NoData
  },
  props: {},
  data() {
    return {
      active: 0, // 当前选中的标签的索引值
      unitName: '博罗县棠下村地下停车场', // 单位名称
      info: {},
      lianResult: ['a', 'b'], // 1.立项用地规划许可阶段
      xukeResult: ['a'], // 2.工程规划许可阶段
      jianduResult: ['a'], // 3.工程建设许可与施工监督阶段
      yanshouResult: ['a'], // 4.竣工验收阶段
      budongchanResult: ['a'], // 5.不动产登记阶段

      projectInfo: {
        // 项目委托数据
        code: '0211020031320000',
        buildingEnt: '南方测绘公司',
        projectName: '专项验收事项',
        projectAddress: '雄安新区国防大厦北区1栋303',
        projectType: '一般社会投资类',
        multiType: '房屋建筑工程',
        contactor: '刘燕燕',
        mobile: '13452020032',
        measureEnt: '雄安工业北方勘察设计研究院有限公司'
      } //
    }
  },
  watch: {},
  computed: {},
  filters: {},
  methods: {
    // 点击每一项标签触发
    onTabClick(idx) {
      this.active = idx
    },
    //
    loadData(data) {
      console.log('data', data)
      this.buildingEnt = this.projectInfo.buildingEnt
      return Promise.resolve(this.rowsList)
      // return this.rowsList
    },
    onselectMultiType() {
      // 多测项目类型选择器
    },
    onselectMeasure() {
      // 测绘作业单位选择器
    },
    queryUnit(){
      // 测绘作业
      this.$router.push({
        path: '/job-unit-query-home'
      })
    }

  },
  created() {
    this.onRefresh()
  },
  mounted() {},
  computed: {}
}
</script>
<style lang="scss" scoped>
.project-progress-update-delegation {
  background: #ffffff;
  /* height: 100vh; */
  overflow: auto;

  .content-box {
    margin: 0 16px;
    .page-title {
      height: 17px;
      font-size: 17px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
      margin: 23px 0 0 0;
      display: flex;
      align-items: center;
    }
    .service-form {
      border: 1px solid #dddddd;
      padding: 18px 10px;
      .service-form-item {
        ::v-deep .van-checkbox {
          height: 10vw;
        }
        ::v-deep .van-checkbox__label {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
        }
        .service-item-title {
          font-size: 14px;
          font-weight: bold;
          color: #333333;
        }
        ::v-deep .van-checkbox__icon {
          background-color: #f4f4f4;
          // border: 1px solid #dddddd;
          width: 14px;
          height: 14px;
        }
        ::v-deep .van-icon {
          width: 14px;
          height: 14px;
          font-size: 9px;
          line-height: 14px;
        }
        ::v-deep .van-checkbox__icon--checked .van-icon {
          color: #999999;
          background-color: #f4f4f4;
          border-color: #dddddd;
        }
      }
    }
    .form-panel {
      .border-field {
        border: 1px solid #dddddd;
      }
      .info-readonly {
        color: #999999;
        ::v-deep .van-field__control {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #999999;
        }
        ::v-deep .selectBtn {
          color: #999999;
        }
      }
      .item-title {
        height: 8vw;
        padding-top: 4vw;
        padding-bottom: 6px;
        display: flex;
        align-items: center;
        position: relative;
      }
      .title-text {
        height: 8vw;
        padding-left: 10px;
        display: flex;
        align-items: center;
        position: relative;
      }
      .title-text::before {
        content: '*';
        color: #fa6366;
        font-size: 14px;
        position: absolute;
        font-weight: 500;
        top: 10px;
        left: 0;
      }
      .red-star {
        color: #fa6366;
        display: flex;
        align-items: center;
      }
    }

    .van-cell {
      background-color: transparent;
    }

    .tips {
      margin: 5vw 0;
      .tips-text {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      .tips-url {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #1d84ff;
        text-decoration: underline;
      }
    }
    .btn-box {
      padding-bottom: 20px;
      .btn-submit {
        background-color: #1d84ff;
        box-shadow: 0px 2px 6px 0px rgba(29, 132, 255, 0.5);
        border-radius: 5px;
        width: 343px;
      }
    }
  }
}
</style>
